import { ChangeDetectionStrategy, Component, ElementRef, HostListener } from '@angular/core';
import { Subscription} from 'rxjs';
import { FocusConfig, ICON_TYPE, LaunchDialogService } from "@spartacus/storefront";

@Component({
    selector: 'gen-checkout-out-of-stock-dialog',
    templateUrl: './checkout-out-of-stock-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GenCheckoutOutOfStockDialogComponent {
  private subscription = new Subscription();
  iconTypes = ICON_TYPE;
  text: string;
  loading: boolean = false;
  modalTitle: string;

  focusConfig: FocusConfig = {
    trap: true,
    block: true,
    autofocus: 'button',
    focusOnEscape: true,
  };

  @HostListener('click', ['$event'])
  handleClick(event: UIEvent): void {
    // Close on click outside the dialog window
    if ((event.target as any).tagName === this.el.nativeElement.tagName) {
      this.close('Close Checkout Out Of Stock Dialog');
    }
  }

  constructor(
    protected launchDialogService: LaunchDialogService,
    protected el: ElementRef,
  ) { }

  ngOnInit(): void {
    this.subscription.add(
      this.launchDialogService.data$.subscribe(
        (data: any) => {
          this.modalTitle = data.text?.split('.')[0];
          this.text = data.text?.split('.').slice(1).join('.');
        }
      )
    );
  }

  public close(reason: string): void {
    this.launchDialogService.closeDialog(reason);
  }

  confirmOutOfStock() {
    this.launchDialogService.closeDialog('confirmOutOfStock');
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.close('Close a dialog');
  }
}
